import base from './base'
import posts from './posts'
import customer from './customer'
import upload from './upload'
import talent from './talent'
import user from './user'
import role from './role'
import manage from './manage'
import salary from './salary'
import setMeal from './set-meal'
import data from './data'
import setPointMeal from './set-point-meal'
import Insurance from './Insurance'
import Enumeration from './Enumeration'
import email from './email'
import thirdyParty from './thirdyParty'
import statistics from './statistics'
import smartAi from './smartAi'
import parkManage from './parkManage'




export default {
  base,
  posts,
  customer,
  upload,
  salary,
  talent,
  user,
  role,
  manage,
  setMeal,
  data,
  setPointMeal,
  Insurance,
  Enumeration,
  email,
  thirdyParty,
  statistics,
  smartAi,
  parkManage
}
